import { InjectionToken } from '@angular/core';
import type { BulkActionEligibilityApi } from './bulk-action-eligibility-evaluator.interfaces';

export const BULK_ACTION_ELIGIBILITY_API =
  new InjectionToken<BulkActionEligibilityApi | null>(
    'BULK_ACTION_ELIGIBILITY_API',
  );
